/**
 * @generated SignedSource<<27c52308bdad654a706eb9f097f55f58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PhoneRegenerateCodeMutationInput = {
  clientMutationId?: string | null;
};
export type PhoneEditConfirmCResendMutation$variables = {
  input: PhoneRegenerateCodeMutationInput;
};
export type PhoneEditConfirmCResendMutation$data = {
  readonly phoneRegenerateCode: {
    readonly __typename: "Influencer";
    readonly newPhone: string | null;
  } | {
    readonly __typename: "PhoneRegenerateCodeError";
    readonly errorType: string;
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PhoneEditConfirmCResendMutation = {
  response: PhoneEditConfirmCResendMutation$data;
  variables: PhoneEditConfirmCResendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newPhone",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PhoneRegenerateCodeError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhoneEditConfirmCResendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneRegenerateCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PhoneEditConfirmCResendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneRegenerateCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cd9b4205979bd3b1a57bf248f02da492",
    "id": null,
    "metadata": {},
    "name": "PhoneEditConfirmCResendMutation",
    "operationKind": "mutation",
    "text": "mutation PhoneEditConfirmCResendMutation(\n  $input: PhoneRegenerateCodeMutationInput!\n) {\n  phoneRegenerateCode(input: $input) {\n    __typename\n    ... on Influencer {\n      newPhone\n      id\n    }\n    ... on PhoneRegenerateCodeError {\n      errorType\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4655cdbe876a046b58b651bc7de216b5";

export default node;
